import "@/App.css";
import { SmoothScroll } from "@/components/landing/SmoothScroll";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Problem } from "@/components/landing/Problem";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { DashboardCards } from "@/components/landing/DashboardCards";
import { SmartNotifications } from "@/components/landing/SmartNotifications";
import { ConnectedWorkspace } from "@/components/landing/ConnectedWorkspace";
import { Outcomes } from "@/components/landing/Outcomes";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

function App() {
  return (
    <SmoothScroll>
      <div className="App relative bg-white text-navy antialiased" data-testid="exception-hub-landing">
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Problem />
          <HowItWorks />
          <DashboardCards />
          <SmartNotifications />
          <ConnectedWorkspace />
          <Outcomes />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

export default App;
